import DashboardRoutes from "./dashboard";
import LoginRoutes from "./authentication";

export const appRoutes = [...LoginRoutes, ...DashboardRoutes];

export default appRoutes;
